module.exports = __webpack_public_path__ + "static/media/empty-star.81df100a.svg";